import { Component } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import swal2 from 'sweetalert2';

/**
 * CREDITOS-REVOLVENTES - Pieza 1: carga de saldos pendientes desde Excel/CSV.
 * Pantalla de administrador (sección Reportes). Sube el archivo con columnas
 * SIAC, RFC, SALDO_PENDIENTE al endpoint upload_pending y muestra el resultado
 * (filas cargadas correctamente y filas con error).
 */
@Component({
  selector: 'app-carga-saldos-revolventes',
  templateUrl: './carga-saldos-revolventes.component.html',
  styleUrls: ['./carga-saldos-revolventes.component.css']
})
export class CargaSaldosRevolventesComponent {

  archivoSeleccionado: File | null = null;
  nombreArchivo = '';
  cargando = false;

  // Resultado de la carga
  resultados: any[] = [];      // filas cargadas correctamente
  errores: any[] = [];         // filas con error
  yaProcesado = false;

  constructor(private reportesService: ReportesService) {}

  // Captura el archivo elegido por el usuario (input file o drag & drop)
  onFileSeleccionado(fileList: FileList) {
    if (!fileList || fileList.length === 0) { return; }
    const file = fileList[0];
    const nombre = file.name.toLowerCase();
    const extensionesValidas = ['.xlsx', '.xls', '.csv'];
    const esValido = extensionesValidas.some(ext => nombre.endsWith(ext));

    if (!esValido) {
      swal2.fire('Archivo no válido', 'Selecciona un archivo .xlsx, .xls o .csv', 'info');
      return;
    }

    this.archivoSeleccionado = file;
    this.nombreArchivo = file.name;
  }

  onInputChange(event: any) {
    this.onFileSeleccionado(event.target.files);
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files) {
      this.onFileSeleccionado(event.dataTransfer.files);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  quitarArchivo() {
    this.archivoSeleccionado = null;
    this.nombreArchivo = '';
  }

  subir() {
    if (!this.archivoSeleccionado) {
      swal2.fire('Sin archivo', 'Primero selecciona un archivo para cargar.', 'info');
      return;
    }

    this.cargando = true;
    this.yaProcesado = false;
    this.resultados = [];
    this.errores = [];
    swal2.showLoading();

    this.reportesService.uploadRevolvingPending(this.archivoSeleccionado).subscribe(resp => {
      swal2.close();
      this.cargando = false;
      this.yaProcesado = true;
      this.resultados = (resp && resp.success) ? resp.success : [];
      this.errores = (resp && resp.errors) ? resp.errors : [];

      if (this.errores.length === 0) {
        swal2.fire('Carga completada', `Se cargaron ${this.resultados.length} saldo(s) correctamente.`, 'success');
      } else {
        swal2.fire(
          'Carga con observaciones',
          `${this.resultados.length} correcto(s), ${this.errores.length} con error. Revisa el detalle.`,
          'warning'
        );
      }
    }, err => {
      swal2.close();
      this.cargando = false;
      console.log(err);
      const msg = (err && err.error && err.error.error) ? err.error.error : 'Ocurrió un error al cargar el archivo.';
      swal2.fire('Error', msg, 'error');
    });
  }
}
